import { useAppSelector } from "@/shared/lib/redux"
import { selectUserIntegration, selectUserIntegrationError, selectUserIntegrationLoading } from "../../model"
import { Loader } from "@/shared/ui/loader"
import { CopyButton } from "../copy-button"
import notify from "@/shared/lib/notify"
import { CreateIntegration } from "../create-integration"
import { UpdateIntegration } from "../update-integration"
import { DeleteIntegration } from "../delete-integration"

export const Integration = () => {
    const integrationError = useAppSelector(selectUserIntegrationError)
    const integration = useAppSelector(selectUserIntegration)
    const integrationLoading = useAppSelector(selectUserIntegrationLoading)

    const handleCopyCallbackUrl = () => {
        navigator.clipboard.writeText(integration.callback_url).then(() => notify.success('Скопировано'))
    }

    return (
        <div className="box">
            <div className="box_header !mb-2 font-mediumttf">
                ИНТЕГРАЦИИ
            </div>
            {integration &&  
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-2">
                        <div className="text-color-secondary uppercase font-bold text-base">
                            URL обратного вызова
                        </div>
                        <div className="text-[13px] font-semibold">
                            На этот адрес будет отправлен вызов при регистрации пользователя
                        </div>
                    </div>
                    <div className="rounded-lg h-[60px] px-2 flex bg-[#FAFAFA] border-[#B9C9C6] items-center w-full border-b">
                        <div className="justify-between w-full flex items-center">
                            <div className="flex items-center gap-[6px]">
                                <CopyButton onClick={handleCopyCallbackUrl} />
                                <div className="font-semibold text-[13px]">
                                    {integration.callback_url}
                                </div>
                            </div>
                            <div className="flex gap-3">
                                <UpdateIntegration />
                                <DeleteIntegration />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {(integrationError?.error_id === 'integration_not_found' && !integrationLoading) &&
                <div className="flex flex-col gap-4">
                    <div className="uppercase text-color-secondary font-bold text-lg">
                        нет активных интеграций
                    </div>
                    <div className="w-full">
                        <CreateIntegration />
                    </div>  
                </div>
            }
            {(!integration && integrationLoading) &&
                <div>
                    <Loader />
                </div>
            }
        </div>
    )
}